import React from 'react';
import { isMobile } from 'react-device-detect';
import NotFound from '../pages/NotFound';
import { ROUTE_CONSTANTS, ROUTE_NAMES } from './constants';

export const PAGE_ROUTES = [
	{
		path: ROUTE_CONSTANTS.LOGIN_PAGE,
		component: React.lazy(() => import('../pages/LoginPage')),
		exact: true,
		name: ROUTE_NAMES.LOGIN_PAGE,
	},
	{
		path: ROUTE_CONSTANTS.HOME_PAGE,
		name: ROUTE_NAMES.HOME_PAGE,
		component: React.lazy(() => import('../pages/LandingPage')),
	},
];

// mobile specific routes
const mobileSpecificRoute = [];

export const getRoutes = () => {
	let allRoutes = [...PAGE_ROUTES];
	if (isMobile) {
		allRoutes = [...allRoutes, ...mobileSpecificRoute];
	}
	const notFoundRound = [
		{
			component: NotFound,
			name: ROUTE_NAMES.NOT_FOUND,
		},
	];

	return [...allRoutes, ...notFoundRound];
};
